import { faChevronDown } from "@jewlr/pro-regular-svg-icons/faChevronDown"
import { faChevronUp } from "@jewlr/pro-regular-svg-icons/faChevronUp"
import PropTypes from "prop-types"
import { useState } from "react"

import { ItemAction } from "areas/cart/components"
import FontAwesomeIcon from "components/ui/font-awesome-icon"

import ItemDetails from "../item-details"

const LineItemDetails = ({ item }) => {
  const [showDetails, toggleShowDetails] = useState(false)
  const itemDetailsId = `cart-item-details-desktop-${item.id}`

  return (
    <div>
      <ItemAction
        aria-controls={itemDetailsId}
        aria-expanded={showDetails}
        onClick={() => toggleShowDetails(!showDetails)}
      >
        View Item Details{" "}
        <FontAwesomeIcon
          className="text-8 align-middle"
          icon={showDetails ? faChevronUp : faChevronDown}
        />
      </ItemAction>
      <ItemDetails
        details={item.view_item_details}
        id={itemDetailsId}
        showDetails={showDetails}
      />
    </div>
  )
}

LineItemDetails.propTypes = {
  item: PropTypes.object,
}

export default LineItemDetails
